import { viewer as initialState } from 'flux/initialState';
import { viewer as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.INITIALIZE: {
      const { initialized, numberOfPages } = action.payload;
      return {
        ...state,
        initialized,
        numberOfPages,
      };
    }
    case types.UPDATE: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    case types.NAVIGATOR_OPEN: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    case types.ZOOMED: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    case types.EXIT: {
      const { initialized } = action.payload;
      return { ...state, initialized };
    }
    case types.SET_CURRENT_FLYER_PAGES: {
      const { flyerId, pages } = action.payload;
      const actualPages = state.flyerPages;
      actualPages[flyerId] = pages;
      return { ...state, flyerPages: actualPages };
    }
    case types.SET_DIRECTION: {
      const { direction } = action.payload;
      return { ...state, direction };
    }
    case types.SET_VIEWER_EXTRAS_BASE: {
      const { extrasBase } = action.payload;
      return { ...state, extrasBase };
    }

    default:
      return state;
  }
}
